export default __webpack_public_path__ + "static/media/god-example.41afa906.png";